import { Box, Stack, ClickAwayListener, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'

interface LanguagesProps {
  minimize?: boolean
  position?: 'top' | 'bottom'
}

const LANGUAGES = [
  { value: 'fr', label: 'FR' },
  { value: 'en', label: 'EN' },
  { value: 'es', label: 'ES' },
  { value: 'de', label: 'DE' },
  { value: 'it', label: 'IT' }
]

const Languages = ({minimize = false, position = 'top'}: LanguagesProps) => {
  const { i18n } = useTranslation()
  const theme = useTheme()
  const [open, setOpen] = useState(false)
  const [activeLanguage, setActiveLanguage] = useState(i18n.language)
  
  return (
    <Box position={'relative'}>
      <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Box
        onClick={() => setOpen(!open)}
        sx={{
          ...(minimize ? {width: '100%', height: '100%', p: 0} : {px: 0.75, py: .5}),
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          gap: 0.2,
          borderRadius: '50%',
          fontSize: minimize ? 11 : 12,
          color: theme.palette.grey[700],
          cursor: 'pointer'
        }}>
        {i18n.language.toUpperCase()}
        {!minimize && <i className={`fa-light fa-angle-${open ? 'down' : 'up'}`} style={{ fontSize: '9px' }} />}
      </Box>
      </ClickAwayListener>
      <Stack
        zIndex={1000}
        boxShadow={'0px 16px 16px -4px #0000003D'}
        mt={1}
        display={open ? 'block' : 'none'}
        border={'1px solid #E7E7E7'}
        p={'6px 14px 6px 14px'}
        borderRadius={'12px'}
        position={'absolute'}
        {...!minimize && {right: 0}}
        top={position === 'top' ? -50 : 16}
        sx={{
          background: 'white'
        }}>
        <Box
          sx={{
            padding: '4px 0 4px 0',
            display: 'flex',
            gap: 1,
            cursor: 'pointer'
          }}>
          {LANGUAGES.map(language => {
            return (
              <Typography
                key={language.value}
                className={activeLanguage && activeLanguage === language.value ? 'active' : ''}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontSize: 12,
                  fontWeight: 500,
                  height: '24px',
                  width: '24px',
                  color: '#5D5D5D',
                  background: 'none',
                  border: '2px solid white',
                  '&:hover': {
                    background: 'none',
                    color: '#3B82F6',
                    fontWeight: 600
                  },
                  '&.active': {
                    border: '2px solid #3B82F6',
                    color: '#282828',
                    borderRadius: '6px',
                    fontWeight: 500
                  }
                }}
                onClick={() => {
                  // hide external components "Donnez votre avis"
                  const el = document.getElementsByClassName('tf-v1-sidetab-button')[0] as HTMLElement | undefined
                  if (el) {
                    el.style.display = language.value === 'fr' ? 'flex' : 'none'
                  }
                  i18n.changeLanguage(language.value)
                  setActiveLanguage(language.value)
                }}>
                {language.label}
              </Typography>
            )
          })}
        </Box>
      </Stack>
    </Box>
  )
}

export default Languages